import { Select } from "antd";
import { SelectComPesquisa } from "../../../SelectComPesquisa";
import { useListarContas } from "../../../../Services/Financeiro/ContaService";
import { EnumTipoConta, TypeConta } from "../../../../Models/Financeiro/Conta";
import { useMemo } from "react";
import Ordenar from "@/Utils/Ordenacao";

export type FiltrosConta = {
    conta?:TypeConta;
    encerrada?:boolean;
    codCentrosDeCustosADV?:number[];
    codTiposInvalidos?:EnumTipoConta[];
}
export interface IContaSelectProps extends Omit<React.ComponentProps<typeof Select>, "onChange" | "showSearch" | "optionFilterProp" | "filterOption"> {
    onChange?:(value:number|undefined, option: unknown, data:TypeConta|undefined) => void;
    filtros?:FiltrosConta;
}
export default function ContaSelect({
    filtros,
    placeholder,
    allowClear,
    options,
    disabled,
    loading,
    onChange,
    ...rest
}:IContaSelectProps) {
    const contaPram:TypeConta = filtros?.conta ?? {} as TypeConta;
    contaPram.ativo = contaPram.ativo ?? true;
    const encerrada = filtros?.encerrada;
    const codCentrosDeCustosADV = filtros?.codCentrosDeCustosADV;
    const codTiposInvalidos = filtros?.codTiposInvalidos;

    const {
        data, 
        isLoading,
        isError
    } = useListarContas({
        contaParam : contaPram,
        encerrada : encerrada,
        codCentrosDeCustosADV : codCentrosDeCustosADV,
        codTiposInvalidos : codTiposInvalidos
    });

    const opcoes = useMemo(() => {
        return [
            ...(data?.sort((a, b) => Ordenar.Booleano(a.encerrada, b.encerrada)) ?? []),
            ...(options ?? [])
        ].map(m => {
            return {
                value : m.codigo,
                label : m.nome + (m.encerrada ? ' (Encerrada)' : '')
            }
        });
    }, [options, data]);

    //Filtros: {JSON.stringify(filtros)}
    return <SelectComPesquisa 
        {...rest}
        placeholder={placeholder ?? "Selecione"}
        allowClear={allowClear ?? true}
        loading={loading || isLoading}
        disabled={(isLoading || isError) ? true : disabled}
        options={opcoes}
        onChange={(v, o) => {
            onChange?.(
                v as number|undefined, 
                o, 
                data?.find(f => f.codigo == v as any)
            );
        }}
    />
}